import React from "react";
import "./WhyUs.css";

// Commitments rather than vanity numbers — keep these true to how the team works.
const STATS = [
  { value: "2 weeks", label: "From idea to AI prototype" },
  { value: "100%", label: "Code & IP ownership for you" },
  { value: "Weekly", label: "Demos and progress reports" },
  { value: "NDA", label: "Signed from day one" },
];

const ENGAGEMENTS = [
  {
    icon: "fa-flask",
    title: "AI Discovery Sprint",
    text: "A 2-week sprint to find your highest-ROI AI use cases and validate them with a working prototype.",
  },
  {
    icon: "fa-cubes",
    title: "Fixed-Scope Project",
    text: "Clear milestones, a fixed budget and a dedicated PM — ideal for MVPs and well-defined products.",
  },
  {
    icon: "fa-people-group",
    title: "Dedicated Team",
    text: "Engineers, designers and AI specialists who work as an extension of your team, scaling up or down as you grow.",
  },
];

// Each sector is paired with a concrete AI use case we can deliver there.
const INDUSTRIES = [
  { icon: "fa-heart-pulse", name: "Healthcare", ai: "Clinical notes, patient triage & health record assistants" },
  { icon: "fa-building-columns", name: "Fintech & Banking", ai: "Fraud detection, KYC document AI & credit scoring" },
  { icon: "fa-shield-halved", name: "Insurance", ai: "Claims automation, underwriting & policy Q&A" },
  { icon: "fa-cart-shopping", name: "E-commerce & Retail", ai: "Recommendations, visual search & shopping assistants" },
  { icon: "fa-graduation-cap", name: "Education & EdTech", ai: "AI tutors, auto-grading & personalised learning" },
  { icon: "fa-users-gear", name: "HR & Recruitment", ai: "Resume screening, candidate matching & onboarding bots" },
  { icon: "fa-scale-balanced", name: "Legal", ai: "Contract review, clause extraction & legal research" },
  { icon: "fa-truck-fast", name: "Logistics & Supply Chain", ai: "Demand forecasting, route optimisation & ETAs" },
  { icon: "fa-industry", name: "Manufacturing", ai: "Visual quality inspection & predictive maintenance" },
  { icon: "fa-house-chimney", name: "Real Estate & PropTech", ai: "Lead qualification, listing copy & valuation models" },
  { icon: "fa-plane-departure", name: "Travel & Hospitality", ai: "Booking assistants, dynamic pricing & reviews insight" },
  { icon: "fa-bullhorn", name: "Media & Marketing", ai: "Content generation, campaign analytics & personalisation" },
  { icon: "fa-futbol", name: "Sports & Fitness", ai: "Performance analytics, contracts & fan engagement" },
  { icon: "fa-seedling", name: "Agriculture", ai: "Crop monitoring, yield prediction & advisory bots" },
  { icon: "fa-bolt", name: "Energy & Utilities", ai: "Load forecasting, asset monitoring & field support" },
  { icon: "fa-cloud", name: "SaaS & Startups", ai: "In-app copilots, AI features & usage insights" },
];

function WhyUs() {
  return (
    <section className="wrapper bg-light why-us">
      <div className="container pb-14 pb-md-16">
        <div className="row g-4 stats-row mb-14">
          {STATS.map((stat) => (
            <div className="col-6 col-lg-3" key={stat.label}>
              <div className="stat-card text-center">
                <div className="stat-number">{stat.value}</div>
                <div className="stat-caption">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="row text-center">
          <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <h2 className="fs-16 text-uppercase text-muted mb-3">Ways to work with us</h2>
            <h3 className="display-4 mb-10 px-xl-10">
              Flexible engagement models built around your goals.
            </h3>
          </div>
        </div>
        <div className="row g-5 mb-14">
          {ENGAGEMENTS.map((item) => (
            <div className="col-md-4" key={item.title}>
              <div className="card shadow-lg h-100 lift">
                <div className="card-body p-6">
                  <span className="engage-icon mb-4">
                    <i className={`fa-solid ${item.icon}`} />
                  </span>
                  <h4 className="mb-2">{item.title}</h4>
                  <p className="mb-0">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mb-8">
          <h2 className="fs-16 text-uppercase text-muted mb-3">Industries we serve</h2>
          <h3 className="display-5 mb-0 px-xl-10">
            AI is reshaping every sector — here’s where we help.
          </h3>
        </div>
        <div className="row g-3 g-md-4">
          {INDUSTRIES.map((industry) => (
            <div className="col-sm-6 col-lg-3" key={industry.name}>
              <div className="industry-card h-100">
                <span className="industry-card-icon">
                  <i className={`fa-solid ${industry.icon}`} />
                </span>
                <div>
                  <h4>{industry.name}</h4>
                  <p>{industry.ai}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
